import { BaseWidget } from ".";
import ImageIcon from '@mui/icons-material/Image';
import ImageControl from "../controls/ImageControl";
import { NumberCssControl } from "../controls/NumberCssControl";

export class ImageWidget extends BaseWidget {
    
    getName() {
        return 'Afbeelding';
    }

    getIcon() {
        return <ImageIcon />;
    }

    getControls() {
        return {
            'image': new ImageControl({
                label: 'Afbeelding',
                description: '',
                defaultValue: '',
                options: {}
            }),
            'width': new NumberCssControl({
                label: 'Breedte',
                description: '',
                defaultValue: {
                    value: 100,
                    unit: 'px'
                },
                options: {
                    units: ['px', '%', 'auto']
                }
            }),
            'height': new NumberCssControl({
                label: 'Hoogte',
                description: '',
                defaultValue: {
                    value: 100,
                    unit: 'px'
                },
                options: {
                    units: ['px', '%', 'auto']
                }
            }),
        };
    }

    /**
     * @param {{
     *     [K in keyof ReturnType<typeof this.getControls>]: ReturnType<typeof this.getControls>[K]['defaultValue']
     * }} props
     * @returns {React.ReactNode}
     */
    render(props) {
        return props.image
            ? <img 
                src={props.image ?? undefined} 
                alt="" 
                className="" 
                /* getCssValue instead of interpolating: it turns unit 'auto'
                   into the keyword `auto`, where the raw template produced the
                   string "nullauto" and the browser dropped the declaration.
                   A banner needs `height: auto` to span the full width without
                   being letterboxed inside a fixed box — every source image has
                   its own aspect ratio, so no single height fits them all. */
                style={{
                    width: props.width ? this.getCssValue(props.width) : undefined,
                    height: props.height ? this.getCssValue(props.height) : undefined,
                }} 
            /> 
            :
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-image" width="48" height="48">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
    }
}
